import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPen1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m6.469 21.25 4.222 4.215L23.363 12.82l-4.226-4.215ZM4 27.922l5.629-1.406L5.406 22.3ZM27.582 6.496l-2.11-2.105a1.497 1.497 0 0 0-2.113 0l-3.168 3.16 4.223 4.215 3.168-3.16a1.485 1.485 0 0 0 0-2.11Zm0 0",
		style: { fillOpacity: 1 }
	})
});
export default SvgPen1;
